import { render, staticRenderFns } from "./CustomPopup.vue?vue&type=template&id=35869d40&scoped=true&"
import script from "./CustomPopup.vue?vue&type=script&lang=js&"
export * from "./CustomPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomPopup.vue?vue&type=style&index=0&id=35869d40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35869d40",
  null
  
)

export default component.exports